import { render, staticRenderFns } from "./card-account-product.vue?vue&type=template&id=3b5d4cbb"
import script from "./card-account-product.vue?vue&type=script&lang=js"
export * from "./card-account-product.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports